// extracted by mini-css-extract-plugin
module.exports = {"previewBoard":"RecentGames_previewBoard__2eTTr"};